module.exports = __webpack_public_path__ + "img/warehouse-transfers.5efab049.png";